import { render, staticRenderFns } from "./SectionRiskCodes.vue?vue&type=template&id=1e588356&scoped=true&"
import script from "./SectionRiskCodes.vue?vue&type=script&lang=js&"
export * from "./SectionRiskCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e588356",
  null
  
)

export default component.exports